var React = require('react');

function Azure (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.867 7.282l-4.733 9.533 8.333 9.66L8 28.23l24 .25zm-.934-3.762L8.067 12.613 0 26.223l6.867-.7z"}));
}

Azure.defaultProps = {"viewBox":"0 0 32 32","width":"64","height":"64","fill":"#035bda","fillRule":"evenodd"};

module.exports = Azure;

Azure.default = Azure;
